<template>
  <base-draggable-modal
      :name="modal_name"
      max-height="80vh"
      width="70vw"
      :fullscreen="$vuetify.display.xsOnly"
      :ref="modal_name">
    <v-card rounded="xl">
      <base-modal>
        <template #header>
          <v-toolbar class="draggable_selector" flat color="secondary" density="compact">
            <v-toolbar-title class="text-primary">{{ $store.getters.translate(page.name) }}</v-toolbar-title>
          </v-toolbar>
        </template>
        <template #content>
          <v-card-text>
            <v-text-field
                class="reg-normal text-primary"
                base-color="border-tertiary"
                bg-color="secondary"
                v-model="search"
                v-debounce:800ms.lock="launchSearch"
                @click:clear="clearSearch"
                :label="$store.getters.translate('search')"
                single-line
                hide-details
                flat
                clearable
                prepend-inner-icon="mdi-magnify"/>
            <v-autocomplete
                class="reg-normal text-primary mt-3"
                base-color="border-tertiary"
                bg-color="secondary"
                density="default"
                v-if="page.name !== 'punchlistitems' && page.name !== 'articles'"
                :label="$store.getters.translate('select_root_assets')"
                v-model="selected_root_assets"
                :items="root_assets"
                item-value="id"
                item-title="name"
                :return-object="false"
                chips
                closable-chips
                multiple
                hide-details
                clearable/>
            <base-tags :modelValue="tags" :isDisabled="page.name === 'punchlistitems'" modal_name="assets" @change="searchByTags"/>
            <template v-if="action === 'copy'">
              <div class="mt-5 ml-2">
                <v-checkbox style="float: left;" color="success" density="compact" hide-details v-model="copy_tags"/>
                <span class="pl-3 sm-normal" style="display: block; height: 40px; align-content: center;">{{ $store.getters.translate('copy_tags') }}</span>
              </div>
              <div class="mt-5 ml-2">
                <v-checkbox style="float: left;" color="success" density="compact" hide-details v-model="copy_documents"/>
                <span class="pl-3 sm-normal" style="display: block; height: 40px; align-content: center;">{{ $store.getters.translate('copy_documents') }}</span>
              </div>
            </template>
            <v-data-table
                class="mt-3"
                v-if="page.name === 'punchlistitems' || page.name === 'articles'"
                :headers="asset_headers"
                :items="assets_array"
                item-value="id"
                selectable-key="id"
                show-select
                v-model="selected_assets"
                v-bind="footer_props">
            </v-data-table>
            <Draggable
                v-else
                ref="tree"
                class="mtl-tree ma-5"
                :defaultOpen="false"
                v-model="assets"
                :disableDrag="true"
                :disableDrop="true"
                indent="20"
                treeLine>
              <template #default="{ node, stat }">
                  <OpenIcon v-if="stat.children && stat.children.length" :open="stat.open" @click.native="stat.open = !stat.open"/>
                  <div v-else style="margin-left: 24px;"/>
                  <v-checkbox color="success" density="compact" v-model="selected_assets" :key="node.id" :value="node.id"/>
                  <span v-if="node && !node.children" class="sm-normal text-primary ma-3" style="cursor: pointer">{{ node.name }}</span>
                  <span v-else class="text-primary ma-3" :class="stat.open ? 'sm-bold' : 'sm-normal'" style="cursor: pointer">{{ node.name }}</span>
              </template>
            </Draggable>
          </v-card-text>
        </template>
        <template #footer>
          <v-card-text>
            <v-row>
              <v-col>
                <base-action-button :width="'100%'" @action="reset">
                  <template #prepend><PhX style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("cancel") }}
                </base-action-button>
              </v-col>
              <v-col>
                <base-action-button :background="true" :width="'100%'" @action="save">
                  <template #prepend><PhFloppyDisk style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("save") }}
                </base-action-button>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
      </base-modal>
    </v-card>
  </base-draggable-modal>
</template>

<script>
import helpFunctions from "../../plugins/helpFunctions.js";
import BaseModal from "./BaseModal";
import BaseDraggableModal from "./BaseDraggableModal";
import BaseTags from "./BaseTags";
import BaseActionButton from "./BaseActionButton";
import {PhFloppyDisk, PhX} from "@phosphor-icons/vue";
import { Draggable, OpenIcon } from '@he-tree/vue';
import '@he-tree/vue/style/default.css';
import '@he-tree/vue/style/material-design.css';

export default {
  props: ["page", "current_assets", "modal_name", "action"],
  components: {
    Draggable,
    OpenIcon,
    BaseActionButton,
    BaseModal,
    BaseDraggableModal,
    BaseTags,
    PhFloppyDisk, PhX,
  },
  data() {
    return {
      all_assets: [],
      all_assets_names: {},
      assets_array: [],
      assets: [],
      copy_tags: false,
      copy_documents: false,
      selected_assets: [],
      open_models: [],
      root_assets: [],
      selected_root_assets: [],
      assets_limit: 10,
      search: null,
      tags: [],
      asset_headers: [{
        title: this.$store.getters.translate("name"),
        align: "start",
        sortable: true,
        value: "name",
      }],
      footer_props: helpFunctions.footer_props,
    };
  },
  created() {
    this.getRootAssets();
  },
  methods: {
    ...helpFunctions.modal_functions,
    load() {
      this.openModal(this.modal_name);
      this.all_assets = [];
      if (this.selected_root_assets.length > 0) {
        clearTimeout(this._timerId);
        this._timerId = setTimeout(() => {
          this.loadSelectedRootAssets();
        }, 1000);
      }
      else if (!this.$store.getters.getLoader) {
        clearTimeout(this._timerId);
        this.getAllAssets();
        for (let i = 0; i < this.assets_limit; i++) {
          this.rootAssetNames(i);
        }
      }
    },
    async getRootAssets() {
      this.root_assets = await helpFunctions.getRootAssets(this.$toast);
    },
    async getAllAssets() {
      this.$store.dispatch('setLoader', true);
      this.all_assets = await helpFunctions.getFullAdditionalModels(this.$toast, "asset");
      this.completeGetAllAssetsFunction();
    },
    async rootAssetNames(limit) {
      let start = limit * 5000;
      let response = await helpFunctions.postCustomRoute(this.$toast, "additional-models-full", { model: "asset", start: start }, false, false);
      this.all_assets_names = {
        ...this.all_assets_names,
        ...response,
      };
      this.assets_limit--;
      if (this.all_assets.length > 0) {
        this.completeGetAllAssetsFunction();
      }
    },
    completeGetAllAssetsFunction() {
      if (this.assets_limit === 0) {
        this.$store.dispatch('setLoader', false);
        this.assets_limit = 10;
        this.combineIDsWithNames(this.all_assets);
        this.all_assets_names = {};
        this.all_assets = this.$lodash.sortBy(this.all_assets, "name");
        this.showRecords();
      }
    },
    async loadSelectedRootAssets() {
      this.all_assets = await helpFunctions.loadSelectedRootAssets(this.$toast, this.selected_root_assets);
      this.showRecords();
    },
    clearSearch() {
      this.search = null;
      this.showRecords();
    },
    launchSearch() {
      if (this.search.length > 2) {
        this.showRecords();
      }
    },
    searchByTags(data) {
      this.tags = data;
      this.showRecords();
    },
    combineIDsWithNames(items) {
      items.forEach((item) => {
        item.name = this.all_assets_names[item.id]["name"];
        if (item.children) {
          this.combineIDsWithNames(item.children);
        }
      });
    },
    createAssetsArray(assets) {
      assets.forEach(asset => {
        if(asset.children) {
          this.createAssetsArray(asset.children);
        }
        else {
          this.assets_array.push({
            id: asset.id,
            name: asset.name
          });
        }
      });
    },
    showRecords() {
      if (this.all_assets.length > 0) {
        this.assets = this.$lodash.cloneDeep(this.all_assets);
        if (this.tags && this.tags.length > 0) {
          let response = helpFunctions.sortByTags(this.assets, this.tags);
          this.assets = response[0];
        }
        if (this.search) {
          let response = helpFunctions.customSearch(this.assets, this.search);
          this.assets = response[0];
          this.open_models = response[2];
        }
        this.assets = helpFunctions.customSortingAndFiltering(this.assets);
        if (this.page.name === 'punchlistitems' || this.page.name === 'articles') {
          this.assets_array = [];
          this.createAssetsArray(this.assets);
        }
        else if (this.open_models.length > 0) {
          setTimeout(() => {
            this.expandFoundNodes(this.open_models);
            this.open_models = [];
          }, 1000);
        }
        if(this.current_assets && this.current_assets.length > 0) {
          this.selected_assets = this.current_assets;
          this.current_assets = [];
        }
      }
    },
    expandFoundNodes(found_models) {
      found_models.forEach(found_model => {
        try {
          const stat = this.$refs.tree.getStat(found_model);
          if (stat) {
            this.$refs.tree.openNodeAndParents(stat);
          }
        } catch (error) {
          console.log(found_model);
        }
      });
    },
    save() {
      if(this.action === 'copy') {
        this.$emit('refresh', { ids: this.selected_assets, copy_tags: this.copy_tags, copy_documents: this.copy_documents });
      }
      else {
        this.$emit('refresh', this.selected_assets);
      }
      this.reset();
    },
    reset() {
      this.all_assets = [];
      this.all_assets_names = {};
      this.assets = [];
      this.copy_tags = false;
      this.copy_documents = false;
      this.selected_assets = [];
      this.root_assets = [];
      this.assets_limit = 10;
      this.search = null;
      this.closeModal(this.modal_name);
    },
  },
  watch: {
    selected_root_assets: {
      handler() {
        this.load();
      },
    },
    selected_assets: {
      handler() {
        if(this.action === "move" && this.selected_assets.length > 1) {
          this.$toast.error(this.$store.getters.translate("only_one_asset_selection"));
          this.selected_assets.pop();
        }
      },
    },
  },
};
</script>

<style scoped>
.v-checkbox {
  display: flex;
}
.he-tree__open-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.v-text-field >>> input {
  font-size: 12px !important;
}
.v-text-field >>> label {
  font-size: 12px !important;
}
</style>